export enum JobTitles {
  PROPERTY_MANAGER = "Property Manager",
  COMPANY_OWNER = "Company Owner",
  PROPERTY_OWNER = "Property Owner",
  ACCOUNTANT = "Accountant",
  HOA_MEMBER_OR_COMMUNITY_MANAGER = "HOA Member or Community Manager",
  OTHER = "Other"
}

export enum JobTitlesMarketing {
  PROPERTY_OWNER = "Property Owner",
  PROPERTY_MANAGER = "Property Manager",
  LANDLORD = "Landlord",
  MANAGEMENT_COMPANY_OWNER = "Management Company Owner",
  HOA_MEMBER_OR_MANAGER = "HOA Member or Manager",
  OTHER = "Other"
}

export enum OtherJobTitles {
  TENANT = "Tenant",
  ACCOUNTANT = "Accountant",
  ATTORNEY = "Attorney",
  OTHER = "Other"
}

export enum WelcomePropertyType {
  RESIDENTIAL = "Residential",
  COMMERCIAL = "Commercial",
  INDUSTRIAL = "Industrial",
  AFFORDABLE = "Affordable Housing",
  STUDENT = "Student Housing",
  ASSOCIATIONS = "Community Associations"
}

export enum WelcomePropertyTypeClient {
  RESIDENTIAL = "Residential",
  COMMERCIAL = "Commercial",
  INDUSTRIAL = "Industrial",
  AFFORDABLE = "Affordable Housing",
  STUDENT = "Student Housing"
}

export enum HOAWelcomePropertyTypeClient {
  RESIDENTIAL = "Residential",
  COMMERCIAL = "Commercial"
}

export enum MainPropertyTypeEnum {
  AFFORDABLE_HOUSING = "Affordable Housing",
  OTHER = "Other",
  COMMUNITY_ASSOCIATIONS = "Community Associations",
  COMMERCIAL = "Commercial",
  RESIDENTIAL = "Residential",
  SHORT_TERM_RENTALS = "Short term rentals",
  STORAGE = "Storage",
  RESIDENTIAL_COMMERCIAL = "Both"
}

export enum WhenPlanToUseSoftware {
  ASAP = "ASAP",
  ONE_TO_THREE_MONTHS = "1-3 Months",
  THREE_TO_SIX_MONTHS = "3-6 Months",
  SIX_MONTHS_PLUS = "6 Months +",
  // HubSpot picklist value is "Just Researching/Browsing"; the user-facing
  // label stays as "Just Researching" via WHEN_PLAN_TO_USE_SOFTWARE_TRANSLATIONS.
  JUST_RESEARCHING = "Just Researching/Browsing"
}

export enum YesNoEnum {
  YES = "Yes",
  NO = "No"
}

export const DataCy = {
  common: {
    doorLoopLogoLoader: "DoorLoop-Logo-Loader"
  },
  marketing: {
    demoForm: {
      continueButton: "DemoForm-ContinueButton",
      stepper: {
        personalInfoButton: "DemoForm-Stepper-PersonalInfoButton",
        companyInfoButton: "DemoForm-Stepper-CompanyInfoButton",
        scheduleButton: "DemoForm-Stepper-ScheduleButton"
      },
      personalInfoStep: {
        emailInput: "DemoForm-PersonalInfoStep-Email",
        fullNameInput: "DemoForm-PersonalInfoStep-FullName",
        phone: "DemoForm-PersonalInfoStep-Phone",
        numberOfUnitsInput: "DemoForm-PersonalInfoStep-NumberOfUnits"
      },
      companyInfoStep: {
        role: "DemoForm-Selection-Role",
        other: "DemoForm-Selection-Other",
        type: "DemoForm-Selection-Type",
        WhenPlanToUseSoftware: "DemoForm-Selection-WhenPlanToUseSoftware"
      }
    }
  }
} as const;
